import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UserInitialsService {

  constructor() { }

  // Returns the initials (first letter) of the given first and last names (e.g., "Test User" -> "TU").
  getUserInitials(firstName: string | null | undefined, lastName: string | null | undefined): string {
    const firstInitial = firstName?.trim() ? firstName.trim()[0].toUpperCase() : '';
    const lastInitial = lastName?.trim() ? lastName.trim()[0].toUpperCase() : '';
    return `${firstInitial}${lastInitial}`;
  }

}
